module.exports = __webpack_public_path__ + "static/media/coin-mining-color.4057901a.svg";